import { useMutation } from '@tanstack/react-query'
import { payWithPayPayApi } from '@!/Api/externalPayment'

export const usePayPayPurchase = () => {
  const mutation = useMutation({
    mutationFn: (productId) => payWithPayPayApi(productId),
  })

  return {
    payWithPayPay: mutation.mutateAsync,
    isLoading: mutation.isPending,
  }
}
